import React, { useContext, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { FundraiserForm } from './FundraiserForm';
import { Fundraisers } from './Fundraisers';
import Registrations from './Registrations';

export const FundraiserIndex = () => {
  return (
    <Switch>
      <Route exact path='/fundraisers' component={Fundraisers} />
      <Route exact path='/fundraisers/add' component={FundraiserForm} />
      <Route exact path='/fundraisers/edit/:id' component={FundraiserForm} />
      <Route
        exact
        path='/fundraisers/registrations/:id'
        component={Registrations}
      />
    </Switch>
  );
};
